var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonCredentialApplication = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M6.01 8h35.98A4.009 4.009 0 0146 12.01v24.028a4.009 4.009 0 01-4.01 4.01H6.01A4.009 4.009 0 012 36.038V12.01A4.009 4.009 0 016.01 8z", fill: fills.light }),
        React.createElement("path", { d: "M19.501 32.067a5.029 5.029 0 01-3.53 1.479h-.069a5.018 5.018 0 01-3.551-1.54 5.01 5.01 0 01-1.415-3.592 5.024 5.024 0 013.978-4.847v-8.369-.757a.995.995 0 111.99 0v1.325h2.13c.55 0 .996.446.996.995v3.172c0 .55-.446.993-.996.995h-2.13v2.62a5.055 5.055 0 014.078 4.918 5.033 5.033 0 01-1.48 3.601zm-5.205-5.245c-.42.42-.681.995-.69 1.64a2.374 2.374 0 002.33 2.412h.023a2.375 2.375 0 002.356-2.387 2.359 2.359 0 00-.705-1.672 2.355 2.355 0 00-1.65-.684h-.024a2.35 2.35 0 00-1.64.691z", fill: fills.dark }),
        React.createElement("path", { d: "M26.067 27.025c0-1.045.847-1.894 1.894-1.894h6.507a1.894 1.894 0 010 3.788H27.96a1.895 1.895 0 01-1.894-1.894zM26.067 20.97c0-1.044.847-1.893 1.894-1.893h8.261a1.894 1.894 0 110 3.788h-8.261a1.894 1.894 0 01-1.894-1.894z", fill: fills.base })));
}, {
    name: identiconComponentName,
})({});
